/**
 * no-scroll helper - to call in every module where its needed
 *
 *
 * Important for some layer:
 *
 * e.preventDefault() the background of the layer-module:
 *   - On mobile devices sometimes it must be prevented
 *     so the body receives the click of the user
 *
 *
 * Examples:
 *
 * this.$module.on('click', (e) =>
 * {
 *      const $clickedTarget = $(e.target);
 *
 *      // desktop
 *      if (S.mq('desktop').matches) { ... do stuff }
 *
 *      // mobile
 *      else { ...
 *
 *          if ($clickedTarget.closest(yourContentWrapper)) {... do stuff}
 *          else { e.preventDefault() }
 *
 *      }
 *
 * });
 **/

/**
 * set no scroll parameters to body
 *
 * @param {Boolean|String} additionalClass if needed for body
 * @param {Boolean|String} addBodyClass add toggle class for body (for input fields on focus)
 * @return {Boolean} true if its finished / false if its already applied
 */
S.setNoScroll = function (additionalClass = false, addBodyClass = false)
{
    // dont know why, but you cant apply the string below without saving it in a var
    const neededTopValue = '-' + window.scrollY + 'px';

    // prevent triggering this all over again if it is already applied
    // dont trigger if body has already the no-scroll class or its top value is the neededTopValue
    if (document.body.style.top === neededTopValue || document.body.classList.contains('no-scroll'))
    {
        // returns false, if the no scroll is already applied or the top value is already set
        return false;
    }

    // add class, if its given
    if (additionalClass)
    {
        document.body.classList.add(additionalClass);
    }

    // Add no-body class to body
    if (addBodyClass)
    {
        document.body.classList.add('no-scroll');
    }

    // returns true if all is applied - if u have to wait for this to trigger
    return true;
};

/**
 * remove no scroll parameter - resets body styles
 *
 * @param {Boolean |String} additionalClass
 * @return {Boolean|String} true if its finished
 */
S.removeNoScroll = function (additionalClass = false)
{
    // add class, if its given
    if (additionalClass)
    {
        document.body.classList.remove(additionalClass);
    }

    document.body.classList.remove('no-scroll');

    // returns true if all is applied - if u have to wait for this to trigger
    return true;
};
